/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PotentialInviteDeclineReasonItem
 */
export interface PotentialInviteDeclineReasonItem {
  /**
   * The unique identifier of the potential invite decline reason.
   * @type number
   * @memberof PotentialInviteDeclineReasonItem
   */
  potentialInviteDeclineReasonKey: number
  /**
   * Description of the potential invite decline reason.
   * @type string
   * @memberof PotentialInviteDeclineReasonItem
   */
  description: string
  /**
   * The order in which the decline reason should be displayed.
   * @type number
   * @memberof PotentialInviteDeclineReasonItem
   */
  displayOrder: number
}

export function PotentialInviteDeclineReasonItemFromJSON(
  json: any
): PotentialInviteDeclineReasonItem {
  return PotentialInviteDeclineReasonItemFromJSONTyped(json, false)
}

export function PotentialInviteDeclineReasonItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PotentialInviteDeclineReasonItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    potentialInviteDeclineReasonKey: json['potentialInviteDeclineReasonKey'],
    description: json['description'],
    displayOrder: json['displayOrder'],
  }
}

export function PotentialInviteDeclineReasonItemToJSON(
  value?: PotentialInviteDeclineReasonItem | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    potentialInviteDeclineReasonKey: value.potentialInviteDeclineReasonKey,
    description: value.description,
    displayOrder: value.displayOrder,
  }
}
